// extracted by mini-css-extract-plugin
export default {"itemsWrapper":"MenuGroupItems_itemsWrapper__+3BvG","item":"MenuGroupItems_item__i7z7q","selected":"MenuGroupItems_selected__zj6yQ","itemText":"MenuGroupItems_itemText__Ffb+C"};